// import node module libraries
import Main from '../../components/Main';
import Section from '../../components/Section';
import { Outlet } from 'react-router';

const AuthLayout = (props) => {
	return (
		<Main className="bg-ready-white">
			<Section className="container d-flex flex-column">
				{props.children}
				<Outlet />
			</Section>
		</Main>
	);
};
export default AuthLayout;
